"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postCouponsIssuePlansValidation = exports.getCouponsIssuePlansValidation = exports.postCouponsValidation = exports.getCouponsValidation = void 0;
var utils_1 = require("./utils");
function getCouponsValidation(getCouponsRequest) {
    var errorList = [];
    var params = getCouponsRequest.params;
    if (!params.page) {
        utils_1.addErrorList(errorList, 'page', 'GET_COUPONS_PAGE_ERROR');
    }
    if (!params.size) {
        utils_1.addErrorList(errorList, 'size', 'GET_COUPONS_SIZE_ERROR');
    }
    if (!params.mallNos) {
        utils_1.addErrorList(errorList, 'mallNos', 'GET_COUPONS_MALLNOS_ERROR');
    }
    if (!params.searchDateType) {
        utils_1.addErrorList(errorList, 'searchDateType', 'GET_COUPONS_SEARCHDATETYPE_ERROR');
    }
    if (!params.startYmd) {
        utils_1.addErrorList(errorList, 'startYmd', 'GET_COUPONS_STARTYMD_ERROR');
    }
    if (!params.endYmd) {
        utils_1.addErrorList(errorList, 'endYmd', 'GET_COUPONS_ENDYMD_ERROR');
    }
    return errorList;
}
exports.getCouponsValidation = getCouponsValidation;
function postCouponsValidation(postCouponsRequest) {
    var errorList = [];
    var data = postCouponsRequest.data;
    if (!data.couponType) {
        utils_1.addErrorList(errorList, 'couponType', 'POST_COUPONS_COUPONTYPE_ERROR');
    }
    if (!data.mallNo) {
        utils_1.addErrorList(errorList, 'mallNo', 'POST_COUPONS_MALLNO_ERROR');
    }
    if (!data.couponName) {
        utils_1.addErrorList(errorList, 'couponName', 'POST_COUPONS_COUPONNAME_ERROR');
    }
    if (!(data.issuableConstraint && data.issuableConstraint.issueLimitCnt && data.issuableConstraint.issueLimitCnt > 0)) {
        utils_1.addErrorList(errorList, 'issuableConstraint', 'POST_COUPONS_ISSUABLECONSTRAINT_ERROR');
    }
    if (!(data.issuableConstraint && data.issuableConstraint.issueStartYmdt)) {
        utils_1.addErrorList(errorList, 'issueStartYmdt', 'POST_COUPONS_ISSUESTARTYMDT_ERROR');
    }
    if (!(data.issuableConstraint && data.issuableConstraint.issueEndYmdt)) {
        utils_1.addErrorList(errorList, 'issueEndYmdt', 'POST_COUPONS_ISSUEENDYMDT_ERROR');
    }
    return errorList;
}
exports.postCouponsValidation = postCouponsValidation;
function getCouponsIssuePlansValidation(getCouponsIssuePlansRequest) {
    var _a;
    var errorList = [];
    var params = getCouponsIssuePlansRequest.params;
    if (params.searchType !== 'ALL') {
        if (((_a = params.keyword) === null || _a === void 0 ? void 0 : _a.trim()) === '') {
            utils_1.addErrorList(errorList, 'keyword', 'PROMOTION_COUPON_ISSUE_KEYWORD_IS_EMPTY');
        }
    }
    if (params.searchType === 'ISSUE_NO' && isNaN(params.keyword)) {
        utils_1.addErrorList(errorList, 'keyword', 'PROMOTION_COUPON_ISSUE_KEYWORD_ONLY_NUMBER');
    }
    if (params.couponIssueStatusTypes === '') {
        utils_1.addErrorList(errorList, 'couponIssueStatusTypes', 'PROMOTION_COUPON_ISSUE_CHECKBOX_MUST_SELECT');
    }
    return errorList;
}
exports.getCouponsIssuePlansValidation = getCouponsIssuePlansValidation;
function postCouponsIssuePlansValidation(postCouponsIssuePlansRequest) {
    var _a, _b, _c, _d, _e, _f;
    var errorList = [];
    var data = postCouponsIssuePlansRequest.data;
    var now = new Date().getTime();
    if (!data.mallNo) {
        utils_1.addErrorList(errorList, 'mallNo', 'PROMOTION_ADDFORM_MALL_IS_EMPTY');
    }
    // ???
    if (data.couponIssueTargetType === 'MEMBER' && !data.couponIssueTargetMember.couponIssueMemberType) {
        utils_1.addErrorList(errorList, 'couponIssueTargetType', 'PROMOTION_ADDFORM_TARGETS_IS_EMPTY');
    }
    if (data.couponIssueTimeType === 'IMMEDIATELY_ISSUE' &&
        !data.couponIssueTargetMember.memberGradeNos.length &&
        !data.couponIssueTargetMember.memberGroupNos.length &&
        !data.couponIssueTargetMember.memberNos) {
        utils_1.addErrorList(errorList, 'couponIssueTargetType', 'PROMOTION_ADDFORM_MEMBER_COUNT_IS_EMPTY');
    }
    if (!data.couponIssueTargetType) {
        utils_1.addErrorList(errorList, 'couponIssueTargetType', 'PROMOTION_ADDFORM_TARGETS_IS_EMPTY');
    }
    if (data.couponIssueTimeType === 'SCHEDULED_ISSUE') {
        if (now - Date.parse((_a = data.requestYmdt) !== null && _a !== void 0 ? _a : '') > 0) {
            utils_1.addErrorList(errorList, 'couponIssueTimeType_SCHEDULED_ISSUE', 'PROMOTION_ADDFORM_NOT_VALID_DATE');
        }
    }
    if (data.couponIssueTimeType === 'PERIOD_ISSUE') {
        if (now - Date.parse((_b = data.periodStartYmdt) !== null && _b !== void 0 ? _b : '') > 0) {
            utils_1.addErrorList(errorList, 'couponIssueTimeType_PERIOD_ISSUE', 'PROMOTION_ADDFORM_NOT_VALID_DATE');
        }
    }
    if (data.useNotification) {
        if (((_c = data.notificationTools) !== null && _c !== void 0 ? _c : '').length === 0) {
            utils_1.addErrorList(errorList, 'useNotification', 'PROMOTION_ADDFORM_NOT_CHECKED_NOTIFICATION_TOOLS');
        }
        if (data.couponIssueTimeType !== 'PERIOD_ISSUE') {
            if (now - Date.parse((_d = data.notificationRequestYmdt) !== null && _d !== void 0 ? _d : '') > 0) {
                utils_1.addErrorList(errorList, 'couponIssueTimeType_PERIOD_ISSUE_NOT', 'PROMOTION_ADDFORM_NOTIFICATION_DATE_MUST_FUTURE_THAN_REQUEST_DATE');
            }
        }
        if (data.couponIssueTimeType === 'SCHEDULED_ISSUE') {
            if (Date.parse((_e = data.requestYmdt) !== null && _e !== void 0 ? _e : '') - Date.parse((_f = data.notificationRequestYmdt) !== null && _f !== void 0 ? _f : '') > 0) {
                utils_1.addErrorList(errorList, 'couponIssueTimeType_SCHEDULED_ISSUE_check', 'PROMOTION_ADDFORM_NOTIFICATION_DATE_MUST_FUTURE_THAN_REQUEST_DATE');
            }
        }
    }
    if (data.couponNos.length === 0) {
        utils_1.addErrorList(errorList, 'couponNos', 'PROMOTION_ADDFORM_NO_COUPON');
    }
    return errorList;
}
exports.postCouponsIssuePlansValidation = postCouponsIssuePlansValidation;
